<template>
  <el-dialog
    :title="$t('text.qr_code')"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :show-close="false"
    @close="closeDialog()"
    width="640px"
    class="edit-group"
  >
    <div ref="print" id="print-box" class="text-center qr-code-wrapper">
      <div v-loading="loading" class="min-h-200 font-22">
        <div class="h-center">
          <div class="avatar v-h-center">{{ qrCodeLabel.split('')[0] }}</div>
          <div class="text-left">
            <div class="black-big-font bold-font main-font font-60">
              {{ qrCodeLabel }}
            </div>
            <div v-if="roomNumber" class="secondary-font">
              {{ $t('text.room_number') }}: {{ roomNumber }}
            </div>
          </div>
        </div>
        <div class="mt-30 mb-20 blue-font bold-font font-30">
          {{ $t('text.smartz_observations') }}
        </div>
        <img
          :src="qrCodeSrcPrefix + qrCodeSrc"
          v-if="qrCodeSrc"
          class="w-220"
        />
        <div
          class="mt-20"
          v-html="$t('text.scan_this_code_to_record_and_observation')"
        ></div>
        <el-divider class="mt-50"></el-divider>
        <div class="h-center mb-40">
          <div>
            <img
              :src="qrCodeSrcPrefix + helpQrCodeSrc"
              v-if="helpQrCodeSrc"
              class="w-70 mr-20"
            />
          </div>
          <div class="text-left">
            <div>{{ $t('text.need_help') }}?</div>
            <div>{{ $t('text.scan_this_code_to_learn_about_smartz') }}</div>
          </div>
        </div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button
        class="save-btn min-w-80"
        @click="print()"
        :disabled="!qrCodeSrc"
        >{{ $t('text.print') }}</el-button
      >
      <el-button class="cancel-btn min-w-80" @click="closeDialog()">{{
        $t('text.cancel').toUpperCase()
      }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import ApiService from '@/services/ApiService.js'
import printJS from 'print-js'
import html2canvas from 'html2canvas'
import swal from 'sweetalert'
export default {
  data() {
    return {
      dialogVisible: false,
      qrCodeSrcPrefix: 'data:image/png;base64,',
      loading: false,
      qrCodeSrc: '',
      qrCodeLabel: '',
      roomNumber: '',
      helpQrCodeSrc: ''
    }
  },
  methods: {
    openDialog(id, isOrganization) {
      this.dialogVisible = true
      this.getQRCode(id, isOrganization)
    },
    closeDialog() {
      this.qrCodeSrc = ''
      this.qrCodeLabel = ''
      this.roomNumber = ''
      this.dialogVisible = false
    },
    getQRCode(id, isOrganization) {
      this.loading = true
      let request = isOrganization
        ? ApiService.GetQRForOrganisation(
            id,
            this.$store.state.locale.currentLocale
          )
        : ApiService.GetQRForPatient(id, this.$store.state.locale.currentLocale)
      request
        .then(response => {
          this.loading = false
          if (response.data.success) {
            this.qrCodeSrc = response.data.data.observationqr || null
            this.qrCodeLabel = isOrganization
              ? response.data.data.name || null
              : response.data.data.alias || null
            this.roomNumber = isOrganization
              ? ''
              : response.data.data.roomNumber
            this.helpQrCodeSrc = response.data.data.helpqr || null
          } else {
            swal({
              icon: 'error',
              timer: 2000,
              title: 'Failed',
              text: response.data.msg
            })
          }
        })
        .catch(() => {
          this.loading = false
        })
    },
    print() {
      window.pageYoffset = 0
      document.documentElement.scrollTop = 0
      document.body.scrollTop = 0
      let options = {
        backgroundColor: null,
        dpi: 300,
        scale: 100,
        removeContainer: false
      }
      html2canvas(this.$refs.print, options).then(canvas => {
        const url = canvas.toDataURL()
        printJS({
          printable: url,
          type: 'image',
          scanStyles: false,
          style: 'body { text-align: center } img {width: 8.5in; height: 11in}'
        })
      })
    }
  }
}
</script>

<style lang="scss">
#print-box {
  img {
    margin: 0 auto;
  }
}
.qr-code-wrapper {
  border: 1px solid #ddd;
  border-radius: 5px;
  padding: 20px;
  box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.2);
  .avatar {
    width: 120px;
    height: 120px;
    border-radius: 60px;
    background-color: #ccc;
    color: white;
    font-weight: bold;
    font-size: 60px;
    margin-right: 20px;
  }
  .el-divider {
    background: #666;
  }
}
</style>
